import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducer from './apple-profiles.reducer';
import { AppleProfilesState } from './apple-profiles.state';

export const selectAppleProfilesState = createFeatureSelector<AppleProfilesState>('apple-profiles');

export const selectProfileIds = createSelector(selectAppleProfilesState, fromReducer.selectProfileIds);

export const selectAppleProfileEntities = createSelector(
  selectAppleProfilesState,
  fromReducer.selectAppleProfileEntities
);

export const selectAllProfiles = createSelector(selectAppleProfilesState, fromReducer.selectAllProfiles);

export const selectSingleAppModeBundleIdentifier = (udid: string) =>
  createSelector(selectAllProfiles, (profiles) => {
    const index = profiles.findIndex(
      (profile) => profile.udid === udid && profile.payloadIdentifier === 'com.methylium.applock'
    );

    return index >= 0 ? extractBundleIdentifierFromPayloadDisplayName(profiles[index].payloadDisplayName) : undefined;
  });

function extractBundleIdentifierFromPayloadDisplayName(payloadDisplayName: string): string {
  return payloadDisplayName.startsWith('App Lock for: ') ? payloadDisplayName.substring(14) : undefined;
}
